import React from 'react';

import HeaderApp from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import ContentChooseTheCustomer from './ContentChooseTheCustomer';

const ChooseTheCustomer = () => {
  return (
    <>
      <HeaderApp />
      <ContentChooseTheCustomer />
      <Bottom />
    </>
  );
};

export default ChooseTheCustomer;
